import { connect } from 'react-redux';
import { List as DictList, mapDispatchToProps } from '../List';
import { REF_NAME, REF_PATH, NAME } from './Const';
import { List as ImmutableList } from 'immutable';

class List extends DictList {
  constructor() {
    super();
    this.setRefPath(REF_PATH);
    this.setRefName(REF_NAME);
    this.setName(NAME);
  }

  renderModificationButtons(id, ref) {
    if (ref.predefine) {
      return '';
    }
    return (super.renderModificationButtons(id, ref));
  }
}

export default connect(state =>
  ({ refs: state.getIn(['references', 'simple', REF_PATH], new ImmutableList()) }),
mapDispatchToProps(REF_NAME, REF_PATH))(List);
